export default __webpack_public_path__ + "static/media/679.7e2a764b.png";